import {
  amplitudeKeyInternal,
  amplitudeKeyOldInternal,
  amplitudeKeyOldProd,
  amplitudeKeyProd,
  appTimestamp,
  appVersion,
  arcgisApiKeyDev,
  autodeskApiUrl,
  commitId,
  commitUrl,
  intercomAppIdDev,
  isNumberedEnv,
  jiraTicketId,
  jiraTicketUrl,
  localizeKey,
  muiProKey,
  numberedEnv,
  procoreApiUrlStaging,
  pullRequestId,
  pullRequestUrl,
  sentryDSNKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "staging",
  appRegion: "eu",
  appEnv: "eu-staging",
  urls: {
    apiBaseUrl: "https://core.api.staging.holobuilder.eu",
    analyticsBaseUrl: "",
    sphereViewerUrl: "https://viewer.staging.holobuilder.eu",
    sphereVaultUrl: "https://vault.staging.holobuilder.eu",
    dashboard20Api: "https://sphere.staging.holobuilder.eu/api",
    hbWebEditorUrl: "https://app.staging.holobuilder.eu",
    progressApiUrl: "https://progress.api.staging.holobuilder.eu",
    sphereEntryPageUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.staging.holobuilder.eu"
        : "https://entry.staging.holobuilder.eu",
    adminPanelUrl: "https://admin.staging.holobuilder.eu",
    cookieManagerUrl:
      "https://cookies.staging.holobuilder.eu/cookie-manager/manager/latest",
    powerBIBaseUrl: "https://hb-powerbi-func-eu-staging.azurewebsites.net",
    projectApiUrl: "https://v2.project.api.staging.holobuilder.eu",
    hbDashboardUrl: "https://dashboard.staging.holobuilder.eu",
    uploadFrontDoorUrl: "https://files.staging.holobuilder.eu",
    uploadStorageUrl: "https://holobuildereucorestorage.blob.core.windows.net",
    activityApiUrl: "https://activity.api.staging.holobuilder.eu",
  },
  features: {
    muiProKey,
    localizeKey,
    sentryDSNKey,
    auth0: {
      domain: "login.eu.stg.farosphere.com",
      clientId: "iRaekFL1jv86gIakQI31pbVMwGLEwB5T",
    },
    amplitudeKeyInternal,
    amplitudeKeyProd,
    amplitudeKeyOldInternal,
    amplitudeKeyOldProd,
    intercomAppId: intercomAppIdDev,
    arcgisApiKey: arcgisApiKeyDev,
  },
  integrations: {
    procoreApiUrl: procoreApiUrlStaging,
    autodeskApiUrl,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu+staging@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
